export default __webpack_public_path__ + "static/media/prompts_notifications.cd13e42f.yaml";